__turbopack_context__.v({
  "brLgOnly": "TeaserNewsletter-module-scss-module__EEVkJG__brLgOnly",
  "brXlOnly": "TeaserNewsletter-module-scss-module__EEVkJG__brXlOnly",
  "card": "TeaserNewsletter-module-scss-module__EEVkJG__card",
  "copy": "TeaserNewsletter-module-scss-module__EEVkJG__copy",
  "disclaimer": "TeaserNewsletter-module-scss-module__EEVkJG__disclaimer",
  "emailInput": "TeaserNewsletter-module-scss-module__EEVkJG__emailInput",
  "errorIcon": "TeaserNewsletter-module-scss-module__EEVkJG__errorIcon",
  "errorMessage": "TeaserNewsletter-module-scss-module__EEVkJG__errorMessage",
  "feedbackRow": "TeaserNewsletter-module-scss-module__EEVkJG__feedbackRow",
  "form": "TeaserNewsletter-module-scss-module__EEVkJG__form",
  "formGrid": "TeaserNewsletter-module-scss-module__EEVkJG__formGrid",
  "hasError": "TeaserNewsletter-module-scss-module__EEVkJG__hasError",
  "inputWrapper": "TeaserNewsletter-module-scss-module__EEVkJG__inputWrapper",
  "starPosition": "TeaserNewsletter-module-scss-module__EEVkJG__starPosition",
  "submitButton": "TeaserNewsletter-module-scss-module__EEVkJG__submitButton",
  "successCopy": "TeaserNewsletter-module-scss-module__EEVkJG__successCopy",
  "successImage": "TeaserNewsletter-module-scss-module__EEVkJG__successImage",
  "successMessage": "TeaserNewsletter-module-scss-module__EEVkJG__successMessage",
  "successTitle": "TeaserNewsletter-module-scss-module__EEVkJG__successTitle",
  "teaserNewsletter": "TeaserNewsletter-module-scss-module__EEVkJG__teaserNewsletter",
  "textColumn": "TeaserNewsletter-module-scss-module__EEVkJG__textColumn",
  "title": "TeaserNewsletter-module-scss-module__EEVkJG__title",
});
